var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DatePicker',{attrs:{"value":_vm.value,"type":_vm.type,"format":_vm.format,"placeholder":_vm.placeholder,"input-class":_vm.inputClass,"input-attr":_vm.inputAttr,"disabled-date":_vm.disabledDate},on:{"input":(v) => _vm.$emit('input', v)}})
}
var staticRenderFns = []

export { render, staticRenderFns }